import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { ParserHelperService } from './parser-helper.service';

/* tslint:disable */
@Injectable()
export class ParserService {

  public parseVars: any = {
    data: {},
    scene: {},
    shapes: {},
    sectors: [],
    zones: [],
    rows: [],
    cells: [],
    titles: {
      row: {option: null, data: null},
      scheme: []
    },
    poster: null,
    defs: [],
    point: '',
    grand: null
  };
  public initTime: number;
  public endTime: number;

  public pointBoundY: number = 25.5;
  public schemaData: ISchemeInfo[] = [];
  public standCell: ISchemeCell[] = [];

  private _logging$$: Subject<ILogging> = new Subject();

  public get logging$(): Observable<ILogging> {
    return this._logging$$.asObservable();
  }

    // tslint:disable-next-line
    private _textPointPositionX: string = '[14.5,16.953125,14.7109375,14.9921875,14.984375,14.6953125,14.6875,15.3671875,14.7734375,14.6875,11.4453125,13.90625,11.6640625,11.9375,11.9296875,11.640625,11.6328125,12.3203125,11.7265625,11.6328125,9.203125,11.6640625,9.421875,9.703125,9.6875,9.40625,9.390625,10.078125,9.484375,9.390625,9.484375,11.9375,9.703125,9.9765625,9.96875,9.6796875,9.671875,10.359375,9.765625,9.671875,9.4765625,11.9296875,9.6875,9.96875,9.9609375,9.671875,9.6640625,10.3515625,9.75,9.6640625,9.1875,11.640625,9.40625,9.6796875,9.671875,9.3828125,9.375,10.0625,9.46875,9.375,9.1796875,11.6328125,9.390625,9.671875,9.6640625,9.375,9.3671875,10.046875,9.453125,9.3671875,9.859375,12.3203125,10.078125,10.359375,10.3515625,10.0625,10.046875,10.734375,10.140625,10.046875,9.265625,11.7265625,9.484375,9.765625,9.75,9.46875,9.453125,10.140625,9.546875,9.453125,9.1796875,11.6328125,9.390625,9.671875,9.6640625,9.375,9.3671875,10.046875,9.453125,9.3671875,5.9375,8.3984375,6.15625,6.4296875,6.421875,6.1328125,6.125,6.8125,6.21875,6.125,8.3984375,10.8515625,8.609375,8.890625,8.8828125,8.59375,8.5859375,9.265625,8.671875,8.5859375,6.15625,8.609375,6.3671875,6.6484375,6.640625,6.3515625,6.34375,7.0234375,6.4296875,6.34375,6.4296875,8.890625,6.6484375,6.9296875,6.921875,6.6328125,6.625,7.3046875,6.7109375,6.625,6.421875,8.8828125,6.640625,6.921875,6.90625,6.625,6.609375,7.296875,6.703125,6.609375,6.1328125,8.59375,6.3515625,6.6328125,6.625,6.3359375,6.328125,7.0078125,6.4140625,6.328125,6.125,8.5859375,6.34375,6.625,6.609375,6.328125,6.3125,7,6.40625,6.3125,6.8125,9.265625,7.0234375,7.3046875,7.296875,7.0078125,7,7.6875,7.09375,7,6.21875,8.671875,6.4296875,6.7109375,6.703125,6.4140625,6.40625,7.09375,6.4921875,6.40625,6.125,8.5859375,6.34375,6.625,6.609375,6.328125,6.3125,7,6.40625,6.3125,3.6953125,6.15625,3.9140625,4.1953125,4.1796875,3.8984375,3.8828125,4.5703125,3.9765625,3.8828125,6.15625,8.609375,6.3671875,6.6484375,6.640625,6.3515625,6.34375,7.0234375,6.4296875,6.34375,3.9140625,6.3671875,4.1328125,4.40625,4.3984375,4.109375,4.1015625,4.7890625,4.1953125,4.1015625,4.1953125,6.6484375,4.40625,4.6875,4.6796875,4.390625,4.3828125,5.0625,4.46875,4.3828125,4.1796875,6.640625,4.3984375,4.6796875,4.671875,4.3828125,4.375,5.0546875,4.4609375,4.375,3.8984375,6.3515625,4.109375,4.390625,4.3828125,4.09375,4.0859375,4.765625,4.171875,4.0859375,3.8828125,6.34375,4.1015625,4.3828125,4.375,4.0859375,4.078125,4.7578125,4.1640625,4.078125,4.5703125,7.0234375,4.7890625,5.0625,5.0546875,4.765625,4.7578125,5.4453125,4.8515625,4.7578125,3.9765625,6.4296875,4.1953125,4.46875,4.4609375,4.171875,4.1640625,4.8515625,4.2578125,4.1640625,3.8828125,6.34375,4.1015625,4.3828125,4.375,4.0859375,4.078125,4.7578125,4.1640625,4.078125,3.9765625,6.4296875,4.1953125,4.46875,4.4609375,4.171875,4.1640625,4.8515625,4.2578125,4.1640625,6.4296875,8.890625,6.6484375,6.9296875,6.921875,6.6328125,6.625,7.3046875,6.7109375,6.625,4.1953125,6.6484375,4.40625,4.6875,4.6796875,4.390625,4.3828125,5.0625,4.46875,4.3828125,4.46875,6.9296875,4.6875,4.96875,4.9609375,4.671875,4.6640625,5.34375,4.75,4.6640625,4.4609375,6.921875,4.6796875,4.9609375,4.9453125,4.6640625,4.6484375,5.3359375,4.7421875,4.6484375,4.171875,6.6328125,4.390625,4.671875,4.6640625,4.375,4.359375,5.046875,4.453125,4.359375,4.1640625,6.625,4.3828125,4.6640625,4.6484375,4.359375,4.3515625,5.0390625,4.4453125,4.3515625,4.8515625,7.3046875,5.0625,5.34375,5.3359375,5.046875,5.0390625,5.71875,5.125,5.0390625,4.2578125,6.7109375,4.46875,4.75,4.7421875,4.453125,4.4453125,5.125,4.53125,4.4453125,4.1640625,6.625,4.3828125,4.6640625,4.6484375,4.359375,4.3515625,5.0390625,4.4453125,4.3515625,3.96875,6.421875,4.1796875,4.4609375,4.453125,4.1640625,4.15625,4.84375,4.25,4.15625,6.421875,8.8828125,6.640625,6.921875,6.90625,6.625,6.609375,7.296875,6.703125,6.609375,4.1796875,6.640625,4.3984375,4.6796875,4.671875,4.3828125,4.375,5.0546875,4.4609375,4.375,4.4609375,6.921875,4.6796875,4.9609375,4.9453125,4.6640625,4.6484375,5.3359375,4.7421875,4.6484375,4.453125,6.90625,4.671875,4.9453125,4.9375,4.6484375,4.640625,5.328125,4.734375,4.640625,4.1640625,6.625,4.3828125,4.6640625,4.6484375,4.359375,4.3515625,5.0390625,4.4453125,4.3515625,4.15625,6.609375,4.375,4.6484375,4.640625,4.3515625,4.34375,5.03125,4.4375,4.34375,4.84375,7.296875,5.0546875,5.3359375,5.328125,5.0390625,5.03125,5.7109375,5.1171875,5.03125,4.25,6.703125,4.4609375,4.7421875,4.734375,4.4453125,4.4375,5.1171875,4.5234375,4.4375,4.15625,6.609375,4.375,4.6484375,4.640625,4.3515625,4.34375,5.03125,4.4375,4.34375,3.6796875,6.1328125,3.8984375,4.171875,4.1640625,3.875,3.8671875,4.5546875,3.9609375,3.8671875,6.1328125,8.59375,6.3515625,6.6328125,6.625,6.3359375,6.328125,7.0078125,6.4140625,6.328125,3.8984375,6.3515625,4.109375,4.390625,4.3828125,4.09375,4.0859375,4.765625,4.171875,4.0859375,4.171875,6.6328125,4.390625,4.671875,4.6640625,4.375,4.359375,5.046875,4.453125,4.359375,4.1640625,6.625,4.3828125,4.6640625,4.6484375,4.359375,4.3515625,5.0390625,4.4453125,4.3515625,3.875,6.3359375,4.09375,4.375,4.359375,4.078125,4.0625,4.75,4.15625,4.0625,3.8671875,6.328125,4.0859375,4.359375,4.3515625,4.0625,4.0546875,4.7421875,4.1484375,4.0546875,4.5546875,7.0078125,4.765625,5.046875,5.0390625,4.75,4.7421875,5.421875,4.828125,4.7421875,3.9609375,6.4140625,4.171875,4.453125,4.4453125,4.15625,4.1484375,4.828125,4.234375,4.1484375,3.8671875,6.328125,4.0859375,4.359375,4.3515625,4.0625,4.0546875,4.7421875,4.1484375,4.0546875,3.671875,6.125,3.8828125,4.1640625,4.15625,3.8671875,3.859375,4.546875,3.953125,3.859375,6.125,8.5859375,6.34375,6.625,6.609375,6.328125,6.3125,7,6.40625,6.3125,3.8828125,6.34375,4.1015625,4.3828125,4.375,4.0859375,4.078125,4.7578125,4.1640625,4.078125,4.1640625,6.625,4.3828125,4.6640625,4.6484375,4.359375,4.3515625,5.0390625,4.4453125,4.3515625,4.15625,6.609375,4.375,4.6484375,4.640625,4.3515625,4.34375,5.03125,4.4375,4.34375,3.8671875,6.328125,4.0859375,4.359375,4.3515625,4.0625,4.0546875,4.7421875,4.1484375,4.0546875,3.859375,6.3125,4.078125,4.3515625,4.34375,4.0546875,4.046875,4.734375,4.140625,4.046875,4.546875,7,4.7578125,5.0390625,5.03125,4.7421875,4.734375,5.4140625,4.8203125,4.734375,3.953125,6.40625,4.1640625,4.4453125,4.4375,4.1484375,4.140625,4.8203125,4.2265625,4.140625,3.859375,6.3125,4.078125,4.3515625,4.34375,4.0546875,4.046875,4.734375,4.140625,4.046875,4.3515625,6.8125,4.5703125,4.8515625,4.84375,4.5546875,4.546875,5.2265625,4.6328125,4.546875,6.8125,9.265625,7.0234375,7.3046875,7.296875,7.0078125,7,7.6875,7.09375,7,4.5703125,7.0234375,4.7890625,5.0625,5.0546875,4.765625,4.7578125,5.4453125,4.8515625,4.7578125,4.8515625,7.3046875,5.0625,5.34375,5.3359375,5.046875,5.0390625,5.71875,5.125,5.0390625,4.84375,7.296875,5.0546875,5.3359375,5.328125,5.0390625,5.03125,5.7109375,5.1171875,5.03125,4.5546875,7.0078125,4.765625,5.046875,5.0390625,4.75,4.7421875,5.421875,4.828125,4.7421875,4.546875,7,4.7578125,5.0390625,5.03125,4.7421875,4.734375,5.4140625,4.8203125,4.734375,5.2265625,7.6875,5.4453125,5.71875,5.7109375,5.421875,5.4140625,6.1015625,5.5078125,5.4140625,4.6328125,7.09375,4.8515625,5.125,5.1171875,4.828125,4.8203125,5.5078125,4.9140625,4.8203125,4.546875,7,4.7578125,5.0390625,5.03125,4.7421875,4.734375,5.4140625,4.8203125,4.734375,3.7578125,6.21875,3.9765625,4.2578125,4.25,3.9609375,3.953125,4.6328125,4.0390625,3.953125,6.21875,8.671875,6.4296875,6.7109375,6.703125,6.4140625,6.40625,7.09375,6.4921875,6.40625,3.9765625,6.4296875,4.1953125,4.46875,4.4609375,4.171875,4.1640625,4.8515625,4.2578125,4.1640625,4.2578125,6.7109375,4.46875,4.75,4.7421875,4.453125,4.4453125,5.125,4.53125,4.4453125,4.25,6.703125,4.4609375,4.7421875,4.734375,4.4453125,4.4375,5.1171875,4.5234375,4.4375,3.9609375,6.4140625,4.171875,4.453125,4.4453125,4.15625,4.1484375,4.828125,4.234375,4.1484375,3.953125,6.40625,4.1640625,4.4453125,4.4375,4.1484375,4.140625,4.8203125,4.2265625,4.140625,4.6328125,7.09375,4.8515625,5.125,5.1171875,4.828125,4.8203125,5.5078125,4.9140625,4.8203125,4.0390625,6.4921875,4.2578125,4.53125,4.5234375,4.234375,4.2265625,4.9140625,4.3203125,4.2265625,3.953125,6.40625,4.1640625,4.4453125,4.4375,4.1484375,4.140625,4.8203125,4.2265625,4.140625,3.671875,6.125,3.8828125,4.1640625,4.15625,3.8671875,3.859375,4.546875,3.953125,3.859375,6.125,8.5859375,6.34375,6.625,6.609375,6.328125,6.3125,7,6.40625,6.3125,3.8828125,6.34375,4.1015625,4.3828125,4.375,4.0859375,4.078125,4.7578125,4.1640625,4.078125,4.1640625,6.625,4.3828125,4.6640625,4.6484375,4.359375,4.3515625,5.0390625,4.4453125,4.3515625,4.15625,6.609375,4.375,4.6484375,4.640625,4.3515625,4.34375,5.03125,4.4375,4.34375,3.8671875,6.328125,4.0859375,4.359375,4.3515625,4.0625,4.0546875,4.7421875,4.1484375,4.0546875,3.859375,6.3125,4.078125,4.3515625,4.34375,4.0546875,4.046875,4.734375,4.140625,4.046875,4.546875,7,4.7578125,5.0390625,5.03125,4.7421875,4.734375,5.4140625,4.8203125,4.734375,3.953125,6.40625,4.1640625,4.4453125,4.4375,4.1484375,4.140625,4.8203125,4.2265625,4.140625,3.859375,6.3125,4.078125,4.3515625,4.34375,4.0546875,4.046875,4.734375,4.140625,4.046875]';
  public pointBound: number[] = JSON.parse(this._textPointPositionX);

  public getParsedSvg(): any {
    this.initTime = performance.now();
    this._logging$$.next({msg: 'Время старта: ' + this.initTime, error: null});

    let x = document.getElementById('svg');

    let y = x.querySelectorAll('#stage > g');
    let yl = y.length;
    for (let i = 0; i < yl; i++) {
        const item = y[i] as Element;
      let groupId: string = item.getAttribute('id');

      switch (groupId) {

        case 'scene' :
            const covers = item.querySelector('#scene-cover') as Element;
            const b = ParserHelperService.getFigurePath(covers);

          if (covers.hasAttribute('fill')) {
              const fill = covers.getAttribute('fill');
              b.forEach((e: ISectorPath) => {
                 if ( e.fill === '' ) {
                     e.fill = fill;
                 }
              });
          }

          if (item.hasAttribute('fill')) {
              const sceneFill = item.getAttribute('fill');
              b.forEach((e: ISectorPath) => {
                  if ( e.fill === '' ) {
                      e.fill = sceneFill;
                  }
              });
          }

          let names: ISceneText[] = ParserHelperService.getSchemeNames(item);

            let muLang: IMultiLang;
            if ( item.querySelector('#lang') ) {
                muLang = ParserHelperService.getShapeLangNames(item);
            } else {
                this._logging$$.next({msg: 'scene No lang dependencies', error: null});
            }

            if (covers.hasAttribute('transform')) {
              const position = covers.getAttribute('transform');
              b.forEach((e: ISectorPath) => {
                  e.transform += position;
              });
          }
          const scenePos = ParserHelperService.getPosition(item.hasAttribute('transform') ? item.getAttribute('transform') : '');
          this.parseVars.scene = {
            position: 'translate(' + scenePos[0] + ', ' + scenePos[1] + ')',
            path: b
          };

            if ( muLang ) {
                this.parseVars.scene['multiTitles'] = muLang;
            } else {
                this.parseVars.scene['titles'] = names;
            }

          break;

        case 'shapes' :
          const sh = ParserHelperService.getFigurePath(item);
          const shapeNames = ParserHelperService.getSchemeNames(item);
          let mLang: IMultiLang = null;

          if ( item.querySelector('#lang') ) {
              mLang = ParserHelperService.getShapeLangNames(item);
              if (!(mLang['uk'] && mLang['ru'] && mLang['en'])) {
                  this._logging$$.next({
                      msg: 'Мультиназвание shape: не определено',
                      error: true
                  });
              }
          } else {
              this._logging$$.next({msg: 'shape No lang dependencies', error: null});
          }

          if ( item.hasAttribute('fill') ) {
            const f = item.getAttribute('fill');
              sh.forEach((el: ISectorPath) => {
                el.fill = f;
            });
          } else if ( item.hasAttribute('fill-opacity') ) {
              const fo = parseFloat( item.getAttribute('fill-opacity') );
              sh.forEach((el: ISectorPath) => {
                  el.fillOpacity = fo;
              });
          } else if ( item.hasAttribute('opacity') ) {
              const oo = item.getAttribute('opacity');
              sh.forEach((el: ISectorPath) => {
                  el.opacity = oo;
              });
          }

            const shapesPos = ParserHelperService.getPosition(item.hasAttribute('transform') ? item.getAttribute('transform') : '');
          this.parseVars.shapes = {
              position: 'translate(' + shapesPos[0] + ', ' + shapesPos[1] + ')',
              path: sh
          };

          if ( mLang ) {
              this.parseVars.shapes['multiNames'] = mLang;
          } else {
              this.parseVars.shapes['names'] = shapeNames;
          }

          break;

        case 'sector' :
          this.getSector(item, i, x);
          break;

        case 'stage-poster' :
            const posterPos = ParserHelperService.getPosition(item.hasAttribute('transform') ? item.getAttribute('transform') : '');
          this.parseVars.poster = {
            position: 'translate(' + posterPos[0] + ', ' + posterPos[1] + ')',
            fill: item.hasAttribute('fill') ? item.getAttribute('fill') : '',
            path: ParserHelperService.getFigurePath(item)
          };
          break;

        case 'stage-title' :
          this.parseVars.titles.scheme = ParserHelperService.getSchemeNames(item);
          break;

        case 'stage-rows' :
          this.parseVars.titles.row = ParserHelperService.getBeautyRowName(item);
          break;

        case 'filter-point' :
          this.parseVars.point = ParserHelperService.getFilterPoint(item);
          break;

        case 'stage-grand' :
            this.parseVars.grand = {
                position: item.hasAttribute('transform') ? item.getAttribute('transform') : '',
                fill: item.hasAttribute('fill') ? item.getAttribute('fill') : '',
                path: ParserHelperService.getFigurePath(item)
            };
            break;

      }

    }
    this.parseVars.data = this.getMapParam(x);
    this.parseVars.cells = this.sortCellInSectorByRow(this.parseVars.sectors, this.parseVars.rows, this.parseVars.cells);

      this.standCell.forEach((cell: ISchemeCell) => {
          this.parseVars.cells.push(cell);
      });
    this.parseVars.defs = this.defsGradient(document.getElementById('svg'));
    let rowTable = this.parseVars.rows.filter((el: ISchemeRow) => el.tables !== null);
    this.parseVars.data['tables'] = rowTable.length ? rowTable : null;
    this.parseVars.groups = this._createUniqGroup(this.parseVars.sectors);
    this.endTime = performance.now();
    this._logging$$.next({msg: 'Финишь: ' + this.endTime, error: null});
    this._logging$$.next({msg: 'Потрачено времени: ' + (this.endTime - this.initTime) + ' мс', error: null});
    console.log('pv', this.parseVars);
    return this.parseVars;
  }

  private _createUniqGroup(sectors: ISchemeSector[]): ISchemeLang[] {
      if ( !sectors.length ) {
          return null;
      }
      let group: ISchemeLang[] = [];
      sectors.forEach((s: ISchemeSector) => {
          if ( s.group ) {
              const inGroup = !!group.find((d: ISchemeLang) => d['uk'] === s.group['uk']);
              if ( !inGroup ) {
                  group.push(s.group);
              }
          }
      });
      return group.length ? group : null;
  }

    public sortCellInSectorByRow(sectors: ISchemeSector[], rows: ISchemeRow[], cells: ISchemeCell[]): ISchemeCell[] {
        let cellSorted: ISchemeCell[] = [];
        const sectorsLength = sectors.length;
        for (let i = 0; i < sectorsLength; i++) {
            if (sectors[i].type !== 1) {

                let nnn = sectors[i].multiName ? sectors[i].multiName['uk'].title : sectors[i].name.title;

                let sectorDataInfo: ISchemeInfo = {
                    sectorName: nnn
                };

                let sectorRowsItem: { row: string|number; rowIds: string[] }[] = [];

                const sectorRows = rows.filter((row) => {
                    const rowParentId = row.parentId.split('_');
                    rowParentId.pop();
                    return rowParentId.join('_') === sectors[i].id;
                });

                const sectorCells = cells.filter((cell) => {
                    const cellParentId = cell.parentId.split('_');
                    cellParentId.pop();
                    cellParentId.pop();
                    return cellParentId.join('_') === sectors[i].id;
                });

                const sectorRowsLength = sectorRows.length;

                for (let k = 0; k < sectorRowsLength; k++) {

                    const row = sectorRows[k];

                    if (sectorRowsItem.find((el) => el.row === row.row)) {
                        const rowIsset = sectorRowsItem.find((el) => el.row === row.row);
                        rowIsset.rowIds.push(row.rowId);
                    } else {
                        sectorRowsItem.push({row: row.row, rowIds: [row.rowId]});
                    }
                }

                sectorRowsItem.sort(this._sortRowIndex);

                const sectorRowsItemLength = sectorRowsItem.length;

                sectorDataInfo.sectorRow = sectorRowsItemLength;
                sectorDataInfo.sectorCell = sectorCells.length;
                sectorDataInfo.rows = [];

                for (let k = 0; k < sectorRowsItemLength; k++) {
                    let r = sectorRowsItem[k];
                    let rowCells = sectorCells.filter((cell) => {
                        return r.rowIds.indexOf(cell.parentId) !== -1;
                    });
                    const rowCellsLength = rowCells.length;
                    rowCells.sort(this._sortCellsObject);
                    for (let c = 0; c < rowCellsLength; c++) {
                        cellSorted.push(rowCells[c]);
                    }
                    sectorDataInfo.rows.push({ name: r.row, count: rowCellsLength });
                }

                this.schemaData.push(sectorDataInfo);
            }
        }
        return cellSorted;
    }

    private _sortRowIndex(a: { row: string; rowIds: string[] }, b: { row: string; rowIds: string[] }): number {

        if (a.row > b.row) {

            if ((parseInt(a.row) - parseInt(b.row)) === 0) {
                return 1;
            } else if ((parseInt(a.row) - parseInt(b.row)) > 0) {
                return 1;
            } else {
                return -1;
            }

        } else {

            if ((parseInt(b.row) - parseInt(a.row)) === 0) {
                return -1;
            } else if ((parseInt(b.row) - parseInt(a.row)) > 0) {
                return -1;
            } else {
                return 1;
            }

        }

    }

    private _sortCellsObject(a: any, b: any): number {


        if (a.cell > b.cell) {

            if ((parseInt(a.cell) - parseInt(b.cell)) === 0) {
                return 1;
            } else if ((parseInt(a.cell) - parseInt(b.cell)) > 0) {
                return 1;
            } else {
                return -1;
            }

        } else {

            if ((parseInt(b.cell) - parseInt(a.cell)) === 0) {
                return -1;
            } else if ((parseInt(b.cell) - parseInt(a.cell)) > 0) {
                return -1;
            } else {
                return 1;
            }

        }
    }

  public defsGradient(svg: HTMLElement): string[] {
    let defs: SVGDefsElement;
    let arr: string[] = [];
    defs = svg.querySelector('defs');
    if ( defs ) {
        for ( let i = 0; i < defs.childElementCount; i++ ) {
            if ( defs.children[i].tagName === 'radialGradient' || defs.children[i].tagName === 'linearGradient' ) {
                arr.push(defs.children[i].outerHTML)
            }
        }
    }
    return arr;
  }


    public getSector(sector: Element, ind: number, stage: Element): void {
        let sectorData: ISchemeSector = {};
        let sectorFigure: ISectorPath;

        let countRow: number = sector.querySelectorAll('#row') ? sector.querySelectorAll('#row').length : 0;
        let countPoint: number = countRow === 0 ? 0 : ParserHelperService.getSectorCountCell(sector);

        let sectorMLang = this.getSectorMultiNames(sector, sector.querySelector('* > #slang'), sector.querySelectorAll('* > #slang > g'));

        if ( sectorMLang ) {
            sectorData.multiName = sectorMLang;
            sectorData.name = {
                title: sectorMLang['uk'].title
            };
            if ( sectorMLang['uk'] && sectorMLang['en'] && sectorMLang['ru'] ) {
                this._logging$$.next({msg: 'Мультиназвание сектора: ' + sectorMLang['uk'].title, error: null});
            } else {
                this._logging$$.next({msg: 'Мультиназвание сектора: не определено', error: true});
            }
        } else {
            let sectorNames: ISectorName = this.getSectorNames(sector);
            if (sectorNames !== undefined) {
                sectorData.name = sectorNames;
                this._logging$$.next({msg: 'Название сектора: ' + sectorNames.title, error: false});
            } else {
                this._logging$$.next({msg: 'Название сектора: не определено', error: true});
            }
        }

        const nnnn = sectorMLang ? sectorMLang['uk'].title : sectorData.name.title;

        this._logging$$.next({msg: 'К-во рядов: ' + countRow, error: false});
        this._logging$$.next({msg: 'К-во мест: ' + countPoint, error: false});


        let sectorEl: Element = sector.querySelector('g[id*="sector-cover"]');
        let sectorElPath: Element;

        if (sectorEl.querySelector('use') !== null && sectorEl.querySelector('use') !== undefined) {
            let sectorElId: string = sectorEl.querySelector('use').getAttribute('xlink:href').split('#')[1];
            sectorElPath = stage.querySelector('defs #' + sectorElId);
            // this._logging$$.next({msg: 'исходник Фигура сектора получили из зависимостей svg defs', error: null});
        } else {
            let sss = sectorEl.querySelectorAll('path, polygon, rect, circle');
            sectorElPath = sss[0] as Element;
            // this._logging$$.next({msg: 'исходник Фигуры сектора получили из группы sector-cover', error: false});
        }

        if (sectorElPath === undefined || sectorElPath === null) {
            sectorFigure = null;
            this._logging$$.next({msg: 'Фигуру сектора НЕ получили', error: true});
        } else {
            sectorFigure = ParserHelperService.getSvgTag(sectorElPath);

            if (sectorEl.hasAttribute('transform')) {
                sectorFigure.transform += sectorEl.getAttribute('transform');
            }
            if (sectorEl.hasAttribute('fill') && sectorFigure.fill === '') {
                sectorFigure.fill = sectorEl.getAttribute('fill');
            }
            if (sectorEl.hasAttribute('fill-opacity')) {
                sectorFigure.fillOpacity = parseFloat(sectorEl.getAttribute('fill-opacity'));
            }
            if (sectorEl.hasAttribute('opacity')) {
                sectorFigure.opacity = sectorEl.getAttribute('opacity');
            }
            this._logging$$.next({msg: 'Фигура сектора получена', error: false});
        }

        let sectorPosition = ParserHelperService.getPosition(sector.hasAttribute('transform') ? sector.getAttribute('transform') : '');
        if (sectorPosition !== undefined && sectorPosition !== null) {
            this._logging$$.next({msg: 'Позиция сектора: [' + sectorPosition[0] + ', ' + sectorPosition[1] + ']', error: false});
        } else {
            this._logging$$.next({msg: 'Позиция сектора: не определена', error: true});
        }

        const sectorBox = sector as SVGGraphicsElement;
        const sectorBoxCenter = this._getOffsetCenter(sectorPosition, sectorBox);

        const sectorPointFilter = sector.querySelector('#filter-point');
        let ffpp = false;
        let fx = 0;
        let fy = 0;
        if ( sectorPointFilter ) {
            const figureSectorPointFilter = sectorPointFilter as SVGGraphicsElement;

            const option = figureSectorPointFilter.getBBox();

            const sectorPointFilterPosition = ParserHelperService.getPosition(sectorPointFilter.hasAttribute('transform') ? sectorPointFilter.getAttribute('transform') : '');

            fx = parseFloat((option.width / 2 + sectorPointFilterPosition[0] ).toFixed(3));
            fy = parseFloat((option.height / 2 + sectorPointFilterPosition[1] ).toFixed(3));
            ffpp = true;
            this._logging$$.next({msg: 'Фильтр точка сектора получена', error: false});
        }

        sectorData.id = 'sector_' + ind;
        sectorData.position = sectorPosition;
        sectorData.figure = sectorFigure;
        sectorData.cover = null;
        sectorData.center = sectorBoxCenter;

        if (countPoint === 0 && countRow === 0) {
            sectorData.type = 1;
            sectorData.rowCount = 1;
            sectorData.cellCount = 0;
            sectorData.cells = [];
        } else {
            sectorData.type = 0;
            sectorData.rowCount = countRow;
            sectorData.cellCount = countPoint ? countPoint : 0;
        }

        if ( sector.querySelector('#old-price') ) {
            sectorData.oldPrice = sector.querySelector('#old-price tspan').textContent;
        }

        if ( ffpp ) {
            sectorData.fx = fx;
            sectorData.fy = fy;
        }

        const sectorGroup: Element = sector.querySelector('#sector-group');

        if ( sectorGroup ) {
            sectorData.group = {};
            const groupNames = sectorGroup.querySelectorAll('text');
            const groupNamesLength = groupNames.length;

            for ( let k = 0; k < groupNamesLength; k++ ) {
                const item = groupNames[k] as Element;
                const code = item.getAttribute('id') === 'ua' ? 'uk' : item.getAttribute('id');
                sectorData.group[code] = item.querySelector('tspan').textContent;
            }

            if ( sectorData.group['uk'] && sectorData.group['en'] && sectorData.group['ru'] ) {
                this._logging$$.next({msg: 'Мультиназвание группы сектора: ' + sectorData.group['uk'], error: null});
            } else {
                this._logging$$.next({msg: 'Мультиназвание группы сектора: не определено', error: true});
            }

        }

        if (sectorData !== undefined) {
            this._logging$$.next({msg: 'Объект сектора сформирован', error: false});
        } else {
            this._logging$$.next({msg: 'Объект сектора не получили', error: true});
        }

        this.parseVars.sectors.push(sectorData);

        if (sectorData.type === 0) {
            this.getSectorZone(sectorData, sector, stage, nnnn, sectorPosition);
        } else {
            let sZone: ISchemeZone = {
                parentId: sectorData.id,
                zoneId: sectorData.id + '_0',
                figure: sectorData.figure,
                number: 0,
                name: '',
                cover: null,
                fullPosition: sectorData.position,
                center: sectorBoxCenter
            };
            let sRow: ISchemeRow = {
                parentId: sectorData.id + '_0',
                rowId: sectorData.id + '_0_0',
                row: '0',
                fullPosition: sectorData.position,
                figure: sectorData.figure,
                tables: null,
                texts: null,
                cover: null
            };

            let sectorDescData = ParserHelperService.createSchemeDesc(sector);
            if ( sectorDescData ) {
                sectorData.multiDesc = sectorDescData;
            }
            let sCell: ISchemeCell = {
                parentId: sectorData.id + '_0_0',
                cell: '0',
                fullPosition: sectorData.position,
                rowSet: 0,
                type: 1,
                textX: null,
                textY: null,
                fanPosition: sectorBoxCenter
            };
            this.parseVars.zones.push(sZone);
            this.parseVars.rows.push(sRow);
            this.parseVars.cells.push(sCell);
            this.standCell.push(sCell);
            this.schemaData.push({ sectorName: nnnn });
        }

    }

  public getSchemeData(): ISchemeInfo[] {
      return this.schemaData.reverse();
  }



  public getMapParam(svg: Element): any {
    let cellH = svg.querySelector('svg');
    let p = {
      width: parseInt(cellH.getAttribute('width').replace('px', ''), 10),
      height: parseInt(cellH.getAttribute('height').replace('px', ''), 10),
      point: {}
    };
    let cell = svg.querySelector('#super-cell');

    if (cell) {
      let text = cell.querySelector('text');
      let cellArr = cell.querySelectorAll('path, rect, circle, polygon');
      let cellData = cellArr[0] as Element;
      let cellTag = ParserHelperService.getSvgTag(cellData);
      p.point = {
        textSize: parseFloat(text.getAttribute('font-size')),
          tag: cellTag
      };
      this._logging$$.next({msg: 'Место super-cell найдено и обработано', error: false});
      return p;
    } else {
      this._logging$$.next({msg: 'Ошибка! Место super-cell НЕ найдено', error: null});
    }

    return p;
  }

  public getSectorMultiNames(sector: Element, langBox: Element, langArr: NodeListOf<Element>): ISectorMultiLang {
      const nA = langArr;
      const box = langBox;
      const nAl = nA.length;

      console.log('langBox', langBox);

      const boxPos = ParserHelperService.getPosition(box.hasAttribute('transform') ? box.getAttribute('transform') : '');
      const boxFz = box.hasAttribute('font-size') ? box.getAttribute('font-size') : null;
      console.log(boxFz);
      const boxFw = box.hasAttribute('font-weight') ? box.getAttribute('font-weight') : null;
      const boxFill = box.hasAttribute('fill') ? box.getAttribute('fill') : null;
      let data: ISectorMultiLang = {};
      for (let i = 0; i < nAl; i++) {
          const item = nA[i] as Element;
          const transform = item.hasAttribute('transform') ? item.getAttribute('transform') : '';
          let pos = ParserHelperService.getPosition(transform);
          pos[0] += boxPos[0];
          pos[1] += boxPos[1];
          let fz = item.hasAttribute('font-size') ? item.getAttribute('font-size') : null;
          if ( boxFz && !fz) {
              fz = boxFz;
          }
          let fw = item.hasAttribute('font-weight') ? item.getAttribute('font-weight') : null;
          if ( boxFw && !fw ) {
              fw = boxFw;
          }
          let fill = item.hasAttribute('fill') ? item.getAttribute('fill') : null;
          if ( boxFill && !fill) {
              fill = boxFill;
          }
          const code = item.getAttribute('id') === 'ua' ? 'uk' : item.getAttribute('id');

          const nameArrUk = item.querySelectorAll('#sector-name');

          data[code] = {
              title: item.querySelector('#sector-name-full').textContent,
              texts: this._createTextArr(nameArrUk, nameArrUk.length, item, pos, fz, fw, fill)
          };
      }

      if (nAl < 1) {
          data = null;
      }
      return data;
  }

  public getSectorNames(sector: Element): ISectorName {
    let name: ISectorName;
    name = {
      title: '',
      texts: []
    };
    let fullName = sector.querySelector('#sector-name-full');

    if (fullName) {
      name.title = fullName.querySelector('tspan').textContent;
      this._logging$$.next({msg: 'Получено полное названия сектора', error: false});
    } else {
      name.title = null;
      this._logging$$.next({msg: 'Нет полного названия сектора', error: true});
    }


    const nameArr = sector.querySelectorAll('#sector-name');
    let nameArrLength = nameArr.length;

    name.texts = this._createTextArr(nameArr, nameArrLength);

    return name;
  }


  private _createTextArr(arr: any, count: number, group?: Element, offset?: number[], fontSize?: string, fontWeight?: string, fill?: string): ISectorNameText[] {
      let snt: ISectorNameText[] = [];
      let gd: IFontData = {};

      if ( !offset ) {
          offset = [0, 0];
      }

      let fz = fontSize ? parseFloat(fontSize) : 18;
      if (group.hasAttribute('font-size')) {
          fz = parseFloat(group.getAttribute('font-size'));
      }
      if ( fontWeight ) {
          gd.fontWeight = fontWeight;
      }
      if (group.hasAttribute('font-weight')) {
          gd.fontWeight = group.getAttribute('font-weight');
      }
      if (fill) {
          gd.fill = fill;
      }
      if (group.hasAttribute('fill')) {
          gd.fill = group.getAttribute('fill');
      }
      gd.x = offset[0];
      gd.y = offset[1];

      for (let i = 0; i < count; i++) {
          let n = arr[i] as Element;
          let ts = n.querySelectorAll('tspan');
          let tsl: number = ts.length;
          let t: ISectorNameText;

          if (n.hasAttribute('font-size')) {
              fz = parseFloat(n.getAttribute('font-size'));
          }

          t = {
              fontSize: fz,
              textArr: [],
              fontWeight: n.hasAttribute('font-weight') ? n.getAttribute('font-weight') : '400',
              fill: n.hasAttribute('fill') ? n.getAttribute('fill') : null,
              opacity: n.hasAttribute('opacity') ? n.getAttribute('opacity') : null
          };

          if (gd.fontWeight && (t.fontWeight === '400')) {
              t.fontWeight = gd.fontWeight;
          }
          if (gd.fill && !t.fill) {
              t.fill = gd.fill;
          }

          for (let k = 0; k < tsl; k++) {
              let nt = ts[k] as Element;
              let ntOpt: ISectorNameTextArray = {
                  t: nt.textContent,
                  x: parseFloat(nt.getAttribute('x')) + gd.x,
                  y: parseFloat(nt.getAttribute('y')) + gd.y,
                  hasPrice: false
              };

              let tc: string = ntOpt.t.toLowerCase();

              if ( tc.includes('грн') || tc.includes('eur') || tc.includes('usd') ) {
                  ntOpt.hasPrice = true;
              }

              console.log('ntOpt', ntOpt);

              t.textArr.push(ntOpt);

          }

          snt.push(t);
      }
      return snt;
  }

  public getSectorZone(sectorData: ISchemeSector, sector: Element, stage: Element, sectorName: string, sectorPosition: number[]): void {

    let zoneArr = sector.querySelectorAll('#zone');

    let zoneArrSize: number = zoneArr.length;
    this._logging$$.next({msg: 'К-во зон сектора' + sectorName + ': ' + zoneArrSize, error: false});

    for (let i = 0; i < zoneArrSize; i++) {
      let zone: ISchemeZone;
      let zoneFigurePath: Element;
      let zoneFigureCover: ISectorPath;
      let zoneIndex: number = null;

      let zoneItem = zoneArr[i] as Element;
      let zoneFigure: Element = zoneItem.querySelector('g[id*="zone-cover"]');
      let zoneIndexG: Element = zoneItem.querySelector('#zone-index');

      if (zoneIndexG !== undefined && zoneIndexG !== null) {
        zoneIndex = parseInt(zoneIndexG.querySelector('tspan').textContent, 10);
      } else {
        zoneIndex = i;
        this._logging$$.next({
          msg: 'Нет индекса для зоны сектора ' + sectorName + ', индекс по умолчанию ' + i + ' и это бок в дальнейшем',
          error: null
        });
      }

      this._logging$$.next({msg: 'Разбираем зону' + zoneIndex + ', сектора ' + sectorName, error: null});

      if (zoneFigure.querySelector('use') !== null && zoneFigure.querySelector('use') !== undefined) {
        let zoneElId: string = zoneFigure.querySelector('use').getAttribute('xlink:href').split('#')[1];
        zoneFigurePath = stage.querySelector('defs #' + zoneElId);
      } else {
          let zzz = zoneFigure.querySelectorAll('path, polygon, rect, circle');
        zoneFigurePath = zzz[0] as Element;
      }

      if (zoneFigurePath === undefined || zoneFigurePath === null) {
        zoneFigureCover = null;
        this._logging$$.next({msg: 'Фигуру зоны НЕ получили', error: true});
      } else {
        zoneFigureCover = ParserHelperService.getSvgTag(zoneFigurePath);

        if (zoneFigure.hasAttribute('transform')) {
          zoneFigureCover.transform += zoneFigure.getAttribute('transform');
        }
        if (zoneFigure.hasAttribute('fill') && zoneFigureCover.fill === '') {
          zoneFigureCover.fill += zoneFigure.getAttribute('fill');
        }
      }

      let zonePosition = ParserHelperService.getPosition(zoneItem.hasAttribute('transform') ? zoneItem.getAttribute('transform') : '');
      let zonePositionFull = ParserHelperService.getFullZonePosition(sectorPosition, zonePosition);
      if (zonePositionFull !== undefined && zonePositionFull !== null) {
        // this._logging$$.next({msg: 'Позиция зоны: [' + zonePositionFull[0] + ', ' + zonePositionFull[1] + ']', error: false});
      } else {
        this._logging$$.next({msg: 'Позиция зоны: не определена', error: true});
      }

      let zoneBox = zoneItem as SVGGraphicsElement;
      let zoneBoxCenter = this._getOffsetCenter(zonePositionFull, zoneBox);

      zone = {
        parentId: sectorData.id,
        zoneId: sectorData.id + '_' + i,
        figure: zoneFigureCover,
        number: i,
        name: '',
        cover: null,
        fullPosition: zonePositionFull,
        center: zoneBoxCenter
      };

      if (!zone) {
        this._logging$$.next({msg: 'Объект зоны не получили', error: true});
      }
      this.parseVars.zones.push(zone);
      this.getSectorZoneRow(zone, zoneItem, stage, zonePosition, sectorPosition, sectorName, zoneIndex);
    }

  }

  private _getOffsetCenter(offset: number[], el: SVGGraphicsElement): number[] {
      const option = el.getBBox();
      return [
          parseFloat(( option.width / 2 + offset[0] ).toFixed(3)),
          parseFloat(( option.height / 2 +  + offset[1] ).toFixed(3))
      ];
  }

  // tslint:disable-next-line
  public getSectorZoneRow(zD: ISchemeZone, z: Element, s: Element, zP: number[], sectorPosition: number[], sectorName: string, zoneIndex: number): void {
    let rowItems = z.querySelectorAll('#row');
    let rowItemsLength = rowItems.length;

    let uniqRowArr = [];
    let uniqRowArrTemp: string[] = [];

    for (let m = 0; m < rowItemsLength; m++) {
        const ri = rowItems[m] as Element;
        let uniqRowText = ri.querySelector('[id*="row-name"]');
        if ( uniqRowText === undefined || uniqRowText === null ) {
            this._logging$$.next({msg: 'Номер ряда не получили', error: true});
        } else {
            let uniqCRowText = uniqRowText.querySelector('text tspan').textContent;
            let uniqFind = uniqRowArrTemp.filter((el) => el === uniqCRowText);
            if (!uniqFind.length) {
                uniqRowArrTemp.push(uniqCRowText);
                uniqRowArr.push(rowItems[m]);
            } else {
                this._logging$$.next({msg: 'Разбираем сектор ' + sectorName + ' зона: ' + zoneIndex + ', дубль ряда ' + uniqCRowText, error: null});
            }
        }
    }

    let uniqRowArrLength: number = uniqRowArr.length;

    for (let i = 0; i < uniqRowArrLength; i++) {

      let row: ISchemeRow;
      let rowElPath: Element;
      let rowElTableFigureEl: Element;
      let rowElFigure: ISectorPath;
      let rowElTableFigure: ISectorPath;
      let rowTable: ISectorRowTable = null;
      let textXy: number[] = [0, 0];
      let rowTableXy: number[] = [0, 0];

      let rowItem: Element = uniqRowArr[i];
      let rowEl: Element = rowItem.querySelector('g[id*="row-cover"]');
      let rowTableEl: Element = rowItem.querySelector('g[id*="row-table"]');

      let rowItemName = rowItem.querySelector('[id*="row-name"]');
      let rowOriginalName: string = '';
      if (rowItemName) {
        let bb = rowItemName.querySelector('tspan');
        rowOriginalName = bb.textContent;
        textXy = [
          parseFloat(bb.getAttribute('x')),
          parseFloat(bb.getAttribute('y')),
        ];
        this._logging$$.next({msg: 'Разбираем ряд ' + rowOriginalName + ' сектор ' + sectorName + ' зоны ' + zoneIndex, error: null});
      } else {
        this._logging$$.next({msg: 'Номер ряда не получили', error: true});
      }

      let cellis = z.querySelectorAll('g[id*="set"] > g');
      let cellisArr = Array.prototype.slice.call(cellis);
      for (let c of cellisArr) {
        c.setAttribute('data-cell', 'yep');
      }
      // this._logging$$.next({msg: 'Расставили точкам ряда атрибут data-cell', error: false});

      if (rowEl.querySelector('use') !== null && rowEl.querySelector('use') !== undefined) {
        let useRowId: string = rowEl.querySelector('use').getAttribute('xlink:href').split('#')[1];
        let rrr = s.querySelectorAll('defs #' + useRowId);
        rowElPath = rrr[0] as Element;
        // this._logging$$.next({msg: 'исходник Фигуры ряда получили из зависимостей svg defs', error: false});
      } else {
        let kkk = rowEl.querySelectorAll('path, polygon, rect, circle');
        rowElPath = kkk[0] as Element;
        // this._logging$$.next({msg: 'исходник Фигуры ряда получили из группы row-cover', error: false});
      }
      if (rowElPath === undefined || rowElPath === null) {
        rowElFigure = null;
        this._logging$$.next({msg: 'Фигуру ряда НЕ получили', error: true});
      } else {
        rowElFigure = ParserHelperService.getSvgTag(rowElPath);
        if (rowEl.hasAttribute('transform')) {
          rowElFigure.transform += rowEl.getAttribute('transform');
        }
        if (rowEl.hasAttribute('fill') && rowElFigure.fill === '') {
          rowElFigure.fill += rowEl.getAttribute('fill');
        }
        this._logging$$.next({msg: 'Фигура ряда получена', error: false});
      }

      let rowPosition = ParserHelperService.getPosition(rowItem.hasAttribute('transform') ? rowItem.getAttribute('transform') : '');
      let rowPositionFull = ParserHelperService.getFullRowPosition(sectorPosition, zP, rowPosition);
      if (rowPositionFull !== undefined && rowPositionFull !== null) {
        this._logging$$.next({msg: 'Позиция ряда: [' + rowPositionFull[0] + ', ' + rowPositionFull[1] + ']', error: false});
      } else {
        this._logging$$.next({msg: 'Позиция ряда: не определена', error: true});
      }

      if (rowTableEl !== null && rowTableEl !== undefined) {

        // this._logging$$.next({msg: 'Найден столик ряда', error: false});

        if (rowTableEl.querySelector('use') !== null && rowTableEl.querySelector('use') !== undefined) {
          let useTableId: string = rowTableEl.querySelector('use').getAttribute('xlink:href').split('#')[1];
          rowElTableFigureEl = s.querySelectorAll('defs #' + useTableId)[0] as Element;
          // this._logging$$.next({msg: 'исходник Фигуры столика получили из зависимостей svg defs', error: false});
        } else {
          rowElTableFigureEl = rowTableEl.querySelectorAll('path, polygon, rect, circle')[0] as Element;
          // this._logging$$.next({msg: 'исходник Фигуры столика получили из группы row-table', error: false});
        }
        if (rowElTableFigureEl === undefined || rowElTableFigureEl === null) {
          rowElTableFigure = null;
          this._logging$$.next({msg: 'Фигуру столика НЕ получили', error: true});
        } else {
          rowElTableFigure = ParserHelperService.getSvgTag(rowElTableFigureEl);
          if (rowTableEl.hasAttribute('transform')) {
            let bla: string = '';
            rowTableXy = ParserHelperService.getPosition(rowTableEl.getAttribute('transform'));
            if (rowPositionFull !== undefined && rowPositionFull !== null) {
              bla = 'translate(' + (rowPositionFull[0] + rowTableXy[0]) + ', ' + (rowPositionFull[1] + rowTableXy[1]) + ')';
            }
            rowElTableFigure.transform = bla;
          }
          if (rowTableEl.hasAttribute('fill') && rowElTableFigure.fill === '') {
              rowElTableFigure.fill += rowTableEl.getAttribute('fill');
          }
          this._logging$$.next({msg: 'Фигура столика получена', error: false});
        }

        rowTable = {
          figure: rowElTableFigure,
          x: parseFloat((textXy[0] - rowTableXy[0]).toFixed(3)),
          y: parseFloat((textXy[1] - rowTableXy[1]).toFixed(3))
        };

      } else {
        this._logging$$.next({msg: 'Фигура столика НЕ получена', error: false});
      }

      row = {
        parentId: zD.zoneId,
        rowId: zD.zoneId + '_' + rowOriginalName,
        row: rowOriginalName,
        fullPosition: rowPositionFull,
        figure: rowElFigure,
        tables: rowTable,
        texts: null,
        cover: null,
      };

      if ( rowItem.querySelector('#lang') ) {
          const nA = rowItem.querySelectorAll('#lang > text');
          const nAl = nA.length;
          for (let i = 0; i < nAl; i++) {
              const item = nA[i] as Element;
              const code = item.getAttribute('id') === 'ua' ? 'uk' : item.getAttribute('id');
              if ( !row.multiName ) {
                  row.multiName = {};
              }
              row.multiName[code] = item.querySelector('tspan').textContent;
          }
          if ( row.multiName['uk'] && row.multiName['ru'] && row.multiName['en'] ) {

          } else {
              this._logging$$.next({msg: 'Мультиназвание ряда: не определено', error: true});
          }
      }

      if (row !== undefined) {
        // this._logging$$.next({msg: 'Объект ряда сформирован ' + row.row, error: false});
      } else {
        this._logging$$.next({msg: 'Объект ряда не получили', error: true});
      }
      this.parseVars.rows.push(row);
      this._logging$$.next({msg: 'Запускаем парсинг точек ряда ' + row.row + ' сектора ' + sectorName + ' зоны ' +  zoneIndex, error: false});
      this.getSectorRowCell(row, rowItem, rowPosition, zP, sectorPosition, rowOriginalName, zoneIndex, sectorName);
    }
  }

  public getSectorRowCell(rD: ISchemeRow, r: Element, rP: number[], zP: number[], sP: number[], rN: string, zI: number, sN: string): void {

    let rs = r.querySelectorAll('g#set');
    let rsLength: number = rs.length;
    this._logging$$.next({msg: 'К-во груп с местами рядом: ' + rsLength, error: false});


    for (let i = 0; i < rsLength; i++) {
        let rit = rs[i] as Element;
      let rowSetPosTemp: string = rit.hasAttribute('transform') ? rit.getAttribute('transform') : 'translate(0, 0)';
      let rowSetPos: number[] = ParserHelperService.getPosition(rowSetPosTemp);
      let cellArr = rit.querySelectorAll('g[data-cell="yep"]');
      let cellArrLength = cellArr.length;

      let uniqCellArr = [];
      let uniqCellArrTemp: string[] = [];

      for (let m = 0; m < cellArrLength; m++) {
          let cccArr = cellArr[m] as Element;
          let uniqCellText = cccArr.querySelector('text tspan').textContent;
          uniqCellText = uniqCellText.trim();
          let uniqFind = uniqCellArrTemp.filter((el) => el === uniqCellText);
          if (!uniqFind.length) {
              uniqCellArrTemp.push(uniqCellText);
              uniqCellArr.push(cccArr);
          } else {
              this._logging$$.next({msg: 'Разбираем сектор: ' + sN + ', зону: ' + zI +' ряд ' + rN + ' группу: ' + i + ', дубль места', error: null});
          }

      }

      let uniqCellArrLength: number = uniqCellArr.length;

      this._logging$$.next({msg: 'Разбираем группу ряда: ' + i + ', с к-вом мест: ' + cellArrLength, error: false});

      for (let k = 0; k < uniqCellArrLength; k++) {
        let cell: ISchemeCell;
        let cellPosTemp: string = uniqCellArr[k].hasAttribute('transform') ? uniqCellArr[k].getAttribute('transform') : 'translate(0, 0)';
        let tempCellPos: number[] = ParserHelperService.getPosition(cellPosTemp);
        let cellPos = ParserHelperService.addSetMarginToCell(rowSetPos, tempCellPos);
        let cellText = uniqCellArr[k].querySelector('text tspan');
        let cellName = cellText.textContent;
        cellName = cellName.trim();
        // this._logging$$.next({msg: 'Разбираем место ' + cellName, error: false});

        let cellPosFull = ParserHelperService.getFullPointPosition(cellPos, rP, zP, sP);
        if (cellPosFull !== undefined && cellPosFull !== null) {
          this._logging$$.next({msg: 'Позиция места: [' + cellPosFull[0] + ', ' + cellPosFull[1] + ']', error: false});
        } else {
          this._logging$$.next({msg: 'Позиция места: не определена', error: true});
        }

        let cellX = this.pointBound[cellName];

        if ( ! cellX ) {
            cellX = parseFloat(cellText.getAttribute('x'));
            // cellX = parseFloat(cellText.getAttribute('x')) + rowSetPos[0];
        }

        cell = {
          parentId: rD.rowId,
          cell: cellName,
          fullPosition: [cellPosFull[0] + 20, cellPosFull[1] + 20],
          rowSet: i,
          type: 0,
          textX: cellX,
          textY: this.pointBoundY
        };

        if ( uniqCellArr[k].getAttribute('id') === 'noeye' ) {
          cell.noeye = true;
        } else if ( uniqCellArr[k].getAttribute('id') === 'invalid' ) {
          cell.cripple = true;
        }

        if (cell !== undefined) {
          // this._logging$$.next({msg: 'Объект места сформирован', error: false});
        } else {
          this._logging$$.next({msg: 'Объект места не получили', error: true});
        }

        this.parseVars.cells.push(cell);

      }
    }
  }
}
/* tslint:enable */
